import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import { DeIcon, FrIcon, RuIcon, UsaIcon } from 'src/assets';
import './languageDropdown.scss';

export const LanguageDropdown = () => {
  const { i18n } = useTranslation();

  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const currentLanguage = i18n.language;

  const containerRef = useRef(null);

  const [isVisibleDropdown, setIsVisibleDropdown] = useState(false);

  const languages = [
    { label: 'EN', value: 'en', icon: UsaIcon },
    { label: 'RU', value: 'ru', icon: RuIcon },
    { label: 'FR', value: 'fr', icon: FrIcon },
    { label: 'DE', value: 'de', icon: DeIcon },
  ];

  const onClickDropdown = useCallback(() => {
    setIsVisibleDropdown((prev) => !prev);
  }, []);

  const onSelectLanguage = useCallback(
    (value) => () => {
      i18n.changeLanguage(value);
      localStorage.setItem('language', value);

      const updatedPath = pathname.replace(/^\/[a-z]{2}(?=\/)/i, value) + search;

      navigate(updatedPath);
    },
    [i18n, navigate, pathname, search],
  );

  const selectedLanguage = languages.find((item) => item.value === currentLanguage);

  useEffect(() => {
    // Handler to detect clicks outside the referenced element
    function handleClickOutside(event) {
      // If the click is outside the containerRef, close it (if open)
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsVisibleDropdown(false);
      }
    }

    // Attach the event listener to the whole document
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup: remove the event listener when this component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="language-dropdown" onClick={onClickDropdown} ref={containerRef}>
      <div className="language-dropdown-item">
        <img src={selectedLanguage.icon} alt={selectedLanguage.icon} />
        <div className="language-dropdown-item-value">{selectedLanguage.label}</div>
      </div>
      {isVisibleDropdown && (
        <div className="language-dropdown-content">
          {languages.map((item, index) => (
            <div
              key={item.value}
              onClick={onSelectLanguage(item.value)}
              className="language-dropdown-item animated-item"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <img src={item.icon} alt={item.icon} />
              <div className="language-dropdown-item-value">{item.label}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
